import {
  Directive,
  effect,
  inject,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import dayjs from 'dayjs';
import { AuthStore } from '../stores/auth.store';

@Directive({
  selector: '[appIsExpired]',
  standalone: true,
})
export class IsExpiredDirective {
  private authStore = inject(AuthStore);
  private viewContainerRef = inject(ViewContainerRef);
  private templateRef = inject(TemplateRef);

  private isVisible = false;

  constructor() {
    effect(() => {
      this.evaluateVisibility();
    });
  }

  private evaluateVisibility() {
    const user = this.authStore.currentUser();

    if (!user?.expireDate) {
      this.clearView();
      return;
    }

    const isValid = dayjs().isBefore(user.expireDate as string | Date);

    if (isValid) {
      this.renderView();
    } else {
      this.clearView();
    }
  }

  private renderView() {
    if (!this.isVisible) {
      this.isVisible = true;
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }

  private clearView() {
    this.isVisible = false;
    this.viewContainerRef.clear();
  }
}
